module.exports = __webpack_public_path__ + "static/media/l3.4b3c52dc.jpg";